import React from "react";

// core components
import { withRouter } from "react-router";
import GridContainer from "common/components/Grid/GridContainer.jsx";
import GridItem from "common/components/Grid/GridItem.jsx";

import Card from "common/components/Card/Card.jsx";
import CardHeader from "common/components/Card/CardHeader.jsx";
import CardIcon from "common/components/Card/CardIcon.jsx";
import CardBody from "common/components/Card/CardFooter.jsx";
import Payment from "@material-ui/icons/Payment";

import dashboardStyle from "assets/jss/material-dashboard-pro-react/views/dashboardStyle";
import withStyles from "@material-ui/core/styles/withStyles";

const importedStyle = dashboardStyle;
const styles = {
  cardIconTitle: importedStyle.cardIconTitle,
  text: {
    margin: 20,
    textAlign: "center",
    alignSelf: "center",
  },
  buttonStyle: {
    margin: "20px",
  },
};

const Declined = (props) => {
  const { classes } = props;

  return (
    <div>
      <GridContainer>
        <GridItem xs={12}>
          <Card>
            <CardHeader color="primary" icon>
              <CardIcon color="primary">
                <Payment />
              </CardIcon>
              <h4 className={classes.cardIconTitle}>EFT / Credit Card</h4>
            </CardHeader>
            <CardBody>
              <GridContainer align="center" justify="center">
                <GridItem xs={12}>
                  <p className={classes.text}>Declined</p>
                </GridItem>
              </GridContainer>
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>
    </div>
  );
};

export default withStyles(styles)(
  withRouter("user.session/autopayment", Declined)
);
